import { atom } from 'jotai';

export const agreementState = atom<string | undefined>(undefined);
